import { ApplicationVersionState } from '@core/application-version/store/states/application-version.state';

export const applicationVersionState = [ApplicationVersionState];
